import assert from 'assert';

const assertString = obj => {
    assert(obj && typeof obj === 'string', 'String expected');
    return obj;
};

const assertFunction = obj => {
    assert(typeof obj === 'function', 'Function expected');
    return obj;
};

class MenuItem {
    constructor(loc) { this._loc = assertString(loc); }
    getLoc() { return this._loc; }

    setSref(sref) {
        this._sref = assertString(sref);
        return this;
    }
    getSref() {
        return this._sref;
    }

    activeWhen(condition) {
        this._active = assertFunction(condition);
        return this;
    }
    isActive($scope) {
        if (!this._active) {
            return false;
        }

        return this._active($scope);
    }

    visibleWhen(condition) {
        this._visible = assertFunction(condition);
        return this;
    }
    isVisible($scope) {
        if (!this._visible) {
            return true;
        }

        return this._visible($scope);
    }
}

export default ['UserInfoService', (UserInfoService) => {
    const activitiesMenuItem = new MenuItem('app.html.index.Activities')
        .setSref('activities.index')
        .activeWhen($scope => $scope.$state.includes('activities'))
        .visibleWhen($scope => $scope.activitiesTurnedOnPSA); // PSA

    if (UserInfoService.isAgent()) {
        return [
            new MenuItem('app.html.index.Accounts')
                .setSref('accounts.index')
                .activeWhen($scope => $scope.$state.includes('accounts')
                    || $scope.$state.includes('gatewaybilling-invoice-payment')
                    || $scope.$state.includes('gateway-billing-make-payment-confirmation')
                    || ($scope.$state.includes('policySelect') && $scope.getType() === 'account'))
                .visibleWhen($scope => $scope.accountAndPoliciesTurnedOnPSA), // PSA

            new MenuItem('app.html.index.Policies')
                .setSref('policies.index')
                .activeWhen($scope => $scope.$state.includes('policies')
                    || ($scope.$state.includes('policySelect') && $scope.getType() === 'policy'))
                .visibleWhen($scope => $scope.accountAndPoliciesTurnedOnPSA), // PSA

            new MenuItem('app.html.index.Claims')
                .setSref('claims')
                .activeWhen($scope => $scope.$state.includes('claims'))
                .visibleWhen($scope => $scope.claimsFeatureTurnedOn),

            activitiesMenuItem,

            new MenuItem('app.html.index.ServiceRequest') // PSA
                .setSref('serviceRequestsList')
                .activeWhen($scope => $scope.$state.includes('serviceRequest') && !$scope.$state.includes('serviceRequestMessages') && !$scope.$state.includes('createMessage') && !$scope.$state.includes('viewReplyMessage'))
                .visibleWhen($scope => $scope.serviceRequestsFeatureTurnedOnPSA),

            new MenuItem('app.html.index.Messages') // PSA
                .setSref('serviceRequestMessages')
                .activeWhen($scope => $scope.$state.includes('serviceRequestMessages') || $scope.$state.includes('createMessage') || $scope.$state.includes('viewReplyMessage'))
                .visibleWhen($scope => $scope.serviceMessagesTurnedOnPSA),

            new MenuItem('app.html.index.CCActivities') // PSA
                .setSref('ccActivitieslist')
                .activeWhen($scope => $scope.$state.includes('ccActivities'))
                .visibleWhen($scope => $scope.ccActivitiesTurnedOnPSA),

            // new MenuItem('app.html.index.Analytics')
            //     .setSref('reports')
            //     .activeWhen($scope => $scope.$state.includes('reports'))
            //     .visibleWhen($scope => $scope.canViewReports),
            new MenuItem('app.html.index.PUWReport')
            .setSref('PUWReport')
            .activeWhen($scope => $scope.$state.includes('reports'))
            .visibleWhen($scope => $scope.canViewReports),
            
            new MenuItem('app.html.index.Commission')
                .setSref('commissions')
                .activeWhen($scope => $scope.$state.includes('commissions'))
                .visibleWhen($scope => $scope.canViewCommissions)
        ];
    }

    return [
        activitiesMenuItem
    ];
}];